var sin;
if (!sin) {
    sin = {};
}

$.extend(sin,
    /**
     * @lends sin
     */
    {
        /**
         * @namespace
         * @description mobile Menu
         */
        mobileMenu: {
            /**
             * @type {function}
             * @description initialize mobile Menu
             */
            init: function() {                       
                var mm = $("#mobileMenu");
                
                mm.append(
                    $("#menu")
                        .clone()
                        .attr("id", "mmenu")
                        .attr("class", "mmenu")
                );

                $("#mobileMenu").mmenu({
                    // options
                    slidingSubmenus: false,
                    extensions: [
                        "pagedim-black",
                        //"position-right",
                        "border-none",
                        "position-front",
                        "shadow-menu",
                        "shadow-panels"
                    ],
                    iconPanels: true,
                    navbar: {
                        title: ""
                    },
                    navbars: [
                        {
                            "position": "top",
                            "content": [                                    
                                'close'
                            ]                            
                        }
                    ]
                }, {
                    // configuration
                    offCanvas: {
                        pageSelector: "#js-mmenu-wrapper"
                    },
                    classNames: {
                        fixedElements: {
                            //fixed: "fix",
                            //sticky: "sticky-top"
                        }
                    }
                });
                
                //remove classnames from cloned mobile menu so no css overwrites are needed
                var mmenu = $('#mmenu');

                mmenu
                    .find('.mm-panel.dropdown-menu')
                    .removeClass('dropdown-menu');
                

                sin.mobileMenu.data = $("#mobileMenu").data("mmenu");
                sin.mobileMenu.eventHandling();
                    
            },
            eventHandling: function(){
                
                $(document).on('click', '.navbar-toggler', function(){
					sin.mobileMenu.data.open();
				});
                
                $(document).on('click', '.navbar-close', function(){
					sin.mobileMenu.data.close();
				});
                
            }
        }
    }
);

$(sin.mobileMenu.init);
